import { cn } from "@/utils/functions";
import queryGenerator from "@/utils/queryGenarator";
import { Form, Input } from "antd";
import axios from "axios";
import { useRef, useState } from "react";
import { useTranslation } from "react-i18next";

export default function ContactEmailField({
  name,
  restField,
  form,
  index,
  isMultiple = false,
  className,
  isUpdate,
  initialSku,
  data,
}) {
  const { t } = useTranslation();
  const debounceTimeoutRef = useRef(null);
  const [emailValid, setEmailValid] = useState("");
  const onChange = async (e) => {
    setEmailValid("loading");
    if (debounceTimeoutRef.current) {
      clearTimeout(debounceTimeoutRef.current);
    }
    if (e.target.value !== "") {
      debounceTimeoutRef.current = setTimeout(async () => {
        const query = queryGenerator({
          query: "isEmail",
          email: e.target.value,
        });
        try {
          const { data } = await axios.get(`contact?${query}`);
          // const { data } = await axios.get(`customer/email?${query}`);
          if (data) {
            setEmailValid(data.status);
          }
        } catch (err) {}
      }, 500);
    } else {
      setEmailValid("");
    }
  };

  let props = {};

  if (emailValid === "true") {
    props = {
      validateStatus: "error",
      help: t("common.emailAlreadyExists"),
    };
  } else if (emailValid === "false") {
    if (!isMultiple) {
      props = {
        validateStatus: "success",
        help: t("common.emailIsAvailable"),
      };
    } else {
      const productGroup = form.getFieldValue("productGroup");
      const value = form.getFieldValue(["productGroup", index, "email"]);
      const filteredProductGroup = productGroup.filter(
        (item, i) => i !== index
      );
      const isExist = filteredProductGroup.some((item) => item.email === value);
      if (isExist) {
        props = {
          validateStatus: "error",
          help: t("common.sameEmailDetected"),
        };
      } else {
        props = {
          validateStatus: "success",
          help: t("common.emailAvailable"),
        };
      }
    }
  } else if (emailValid === "loading") {
    props = {
      validateStatus: "validating",
      help: t("common.validatingEmail"),
    };
  }

  const emailRegex = /^[^\s@]+@[^\s@]+$/;
  const validatorArray = [
    {
      validator: (_, value) => {
        return new Promise((resolve, reject) => {
          if (!value) {
            reject(t("common.pleaseEnterEmail"));
          } else if (!emailRegex.test(value)) {
            reject(t("common.pleaseEnterValidEmail"));
          }
          if (emailValid === "true") {
            reject(t("common.thisEmailAlreadyInUse"));
          } else {
            resolve();
          }
        });
      },
    },
  ];

  const updateArray = [
    {
      validator: (_, value) => {
        return new Promise((resolve, reject) => {
          if (!value) {
            reject(t("common.pleaseEnterEmail"));
            return;
          }
          if (emailValid === "true") {
            reject(t("common.thisEmailAlreadyInUseLower"));
          } else if (emailValid === "false" || initialSku === value) {
            resolve();
          } else {
            resolve();
          }
        });
      },
    },
  ];

  return (
    <>
      <Form.Item
        style={{ marginBottom: "15px" }}
        label={t("common.email")}
        name={name}
        className={cn("", {
          [className]: className,
          "mb-1 w-1/2": !className,
        })}
        hasFeedback
        required
        {...props}
        rules={isUpdate ? updateArray : validatorArray}>
        <Input onChange={onChange} placeholder={t("common.email")} />
      </Form.Item>
    </>
  );
}

// EmailField
